import { Component, OnInit, Output, Input, EventEmitter, OnDestroy, ElementRef, HostListener, ChangeDetectorRef, ViewRef } from '@angular/core';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';
import { QuoteDataCaptureService, UtilService } from 'src/app/shared';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { map } from 'rxjs/operators';
import { KeyValueModel } from 'src/app/model/key-value.model';
import { HealthService } from 'src/app/core/cms/health/health.service';
import { LifeStyleQuestion } from 'src/app/pages/medical-underwriting/model/lifestyle.model';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Tooltip } from 'src/app/model/tooltip';
import { SyncService } from 'src/app/pages/medical-underwriting/services/sync.service';
import { MedCondClassificationModel, SubAndClassificationModel, EmitterToCtlTypeModel, MedicationQuestionStoreModel, AccordQuestionStoreModel } from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { MedClassificationPattern } from 'src/app/pages/medical-underwriting/medical-underwrting.constants';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import { AlertModal } from 'src/app/model/alert';

@Component({
  selector: 'app-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss']
})
export class SearchInputComponent implements OnInit, OnDestroy {

  enteredValue: string;
  searchLstSubs: Subscription;


  addressList: string[];
  addressObjList: MedCondClassificationModel[];
  addressData: any[] = [];
  private selectedTitle: string;
  isMedicationObjectType: boolean = false;


  @Input() question: LifeStyleQuestion;
  @Input() parent: UntypedFormGroup;
  @Input() controlName: string;
  @Input() indexToAppend: number;
  @Input() accordIndexToAppend: number;
  @Input() objToReferForAccord: AccordQuestionStoreModel;
  domId: string;
  @Input() objToReferToRetainValueFromTabSquare: MedicationQuestionStoreModel;
  @Input() editMode: boolean;
  @Output() selectedData: EventEmitter<any> = new EventEmitter<any>();
  @Output() editModelHandler: EventEmitter<any> = new EventEmitter();
  public tooltipModalConfig: AlertModal;
  tooltipModal;
  displayTooltipAlert: boolean = false;
  subscription: Subscription;

  constructor(private healthService: HealthService, private cdRef: ChangeDetectorRef, private utilService: UtilService,
    private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private fb: UntypedFormBuilder, private syncService: SyncService, private activatedRoute: ActivatedRoute) {
      this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.syncService.getInitialQuestionJson().subscribe((res) => {
      this.selectedTitle = res.tittle;
    });

    this.subscription = this.utilService.emitInput.subscribe(val => {
      if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
        this.cdRef.detectChanges();
      }
    });

  }

  ngOnInit() {
    this.domId = this.utilityServiceForMedicalService.getDomId(this.question.id, this.accordIndexToAppend, this.indexToAppend);
    this.controlName = this.utilityServiceForMedicalService.getControlName(this.question.id, this.accordIndexToAppend);
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.searchLstSubs = this.healthService.getMedicineNamesJson(this.question.responseMethod).subscribe(res => {
      if (res.Medicine) {
        this.isMedicationObjectType = false;
        this.addressList = res.Medicine;
        this.prepareResValueForSearchInput();
      } else if (res.medConditions) {
        res.medConditions.forEach(element => {
          if (element.MedicalCondition === this.selectedTitle) {
            this.isMedicationObjectType = true;
            this.addressObjList = element.subConditions;
          }
        });
        this.prepareResValueForSearchInput();
      }

    });
    if (this.parent.controls[this.controlName]) {
      this.syncService.businessValidationEvent.subscribe((res) => {
        this.checkInputValues();
      });
    }
  }


  prepareResValueForSearchInput() {
    if (this.objToReferForAccord && this.objToReferForAccord.accordionIndex === this.accordIndexToAppend) { // preference goes to accordion
      let result = this.objToReferForAccord.questionList.find((item) => item.id === this.question.id);
      if (result && result.responseValue) {
        this.question.responseValueByUser = result.responseValue;
      }
    }
    else if (this.objToReferToRetainValueFromTabSquare && this.objToReferToRetainValueFromTabSquare.indexToSave === this.indexToAppend.toString()) {
      let result = this.objToReferToRetainValueFromTabSquare.questionList.find((item) => item.id === this.question.id);
      if (result && result.responseValue) {
        this.question.responseValueByUser = result.responseValue;
      }
    }
    if (this.question.responseValueByUser) {
      this.setValueForInputBox(this.question, this.question.responseValueByUser);
      if (this.isMedicationObjectType) {
        let tempClassification: string;
        let temp = this.addressObjList.find(item => item.subCondition === this.question.responseValueByUser);
        tempClassification = temp ? temp.classification : null;
        let classificationAndSubCondObj = new MedCondClassificationModel();
        classificationAndSubCondObj.subCondition = this.question.responseValueByUser;
        classificationAndSubCondObj.classification = tempClassification;
        this.onSelectOfSearchResultsAsObj(classificationAndSubCondObj, false);
      }
      else {
        this.onSelectOfSearchResultsAsString(this.question.responseValueByUser, false);
      }
    }
  }

  setValueForInputBox(question: LifeStyleQuestion, selectedValue: string) {
    if (this.parent.controls[this.controlName]) {
      this.parent.controls[this.controlName].setValue(selectedValue);
    }
    else {
      this.parent.addControl(this.controlName, this.fb.control(null, question.mandatoryResponse.toUpperCase() === 'YES' ? Validators.required : null));
      this.parent.controls[this.controlName].setValue(selectedValue);
    }
  }

  Search() {
   let invalidRegExp = /^[A-Za-z0-9 _,-]*[A-Za-z0-9][A-Za-z0-9 _,-]*$/;
    if( !invalidRegExp.test( this.enteredValue )) {
      this.setAddressDataArrayEmpty();
      return false;
  }
    if (this.editMode) { // if (this.editMode && !onPageLoad) {
      const payload = {
        value: this.question.responseValueByUser,
        screen: 'input-search'
      };
      if (!this.subscription) {
        this.subscription = this.utilService.updateEditForm.subscribe(res => {
          if (res) {
            if (res.action && res.action === 'cancel') {
              this.revertSearch(res.value);
            } else {
              this.editMode = false;
              this.Search();
            }
          }
        });
      }
      this.editModelHandler.emit(payload);
    } else {
      if (this.enteredValue !== '') {
        if (this.isMedicationObjectType) {
          this.addressData = this.addressObjList.filter(res => {
            return res.subCondition.toLocaleLowerCase().match(this.enteredValue.toLocaleLowerCase());
          }).slice(0, 51);

        } else if (!this.isMedicationObjectType) {
          this.addressData = this.addressList.filter(res => {
            return res.toLocaleLowerCase().match(this.enteredValue.toLocaleLowerCase());
          }).slice(0, 51);
        }
      } else if (this.enteredValue === '') {
        this.addressData = [];
      }
    }
  }
  revertSearch(inputValue?: string) {
    if (inputValue) {
      this.enteredValue = inputValue;
    }
    if (this.enteredValue !== '') {
      if (this.isMedicationObjectType) {
        this.addressData = this.addressObjList.filter(res => {
          return res.subCondition.toLocaleLowerCase().match(this.enteredValue.toLocaleLowerCase());
        }).slice(0, 51);

      } else if (!this.isMedicationObjectType) {
        this.addressData = this.addressList.filter(res => {
          return res.toLocaleLowerCase().match(this.enteredValue.toLocaleLowerCase());
        }).slice(0, 51);
      }
    } else if (this.enteredValue === '') {
      this.addressData = [];
    }
  }

  checkInputValues() {
    if (this.enteredValue === '' || this.enteredValue === null || this.enteredValue === undefined || this.enteredValue === this.question.responseValueByUser) {
      this.addressData = [];
    } else if (this.addressData && this.addressData.length === 1 && !this.isMedicationObjectType) {
      if (this.enteredValue.toLowerCase().trim() === this.addressData[0].toLowerCase().trim()) {
        this.onSelectOfSearchResultsAsString(this.addressData[0], true);
        this.parent.controls[this.controlName].setErrors(null);
      } else {
        this.setAddressDataArrayEmpty();
      }
    } else if (this.addressData && this.addressData.length === 1 && this.isMedicationObjectType) {
      if (this.enteredValue.toLowerCase().trim() === this.addressData[0].subCondition.toLowerCase().trim()) {
        this.onSelectOfSearchResultsAsObj(this.addressData[0], true);
        this.parent.controls[this.controlName].setErrors(null);
      } else {
        this.setAddressDataArrayEmpty();
      }
    } else if (this.addressData && this.addressData.length > 1) {
      this.setAddressDataArrayEmpty();
    } else if (this.addressData && this.addressData.length === 0) {
      let matchedValue = this.findSelectedValueInTheList();
      if (matchedValue !== -1 && matchedValue !== undefined) {
        this.isMedicationObjectType ? this.onSelectOfSearchResultsAsObj(matchedValue, true) : this.onSelectOfSearchResultsAsString(matchedValue, true);
      } else if (matchedValue === -1 || matchedValue === undefined) {
        this.parent.controls[this.controlName].setErrors({ invalid: true });
      }
    }
  }

  setAddressDataArrayEmpty() {
    setTimeout(() => {
      if (this.addressData && this.addressData.length !== 0) {
        this.addressData = [];
        this.parent.controls[this.controlName].setErrors({ invalid: true });
        this.cdRef.detectChanges();
      }
    }, 200);
  }

  findSelectedValueInTheList() {
    let temp;
    if (!this.isMedicationObjectType) {
      temp = this.addressList.find(res => res.toLocaleLowerCase() === this.enteredValue.toLocaleLowerCase());
    } else if (this.isMedicationObjectType) {
      temp = this.addressObjList.find(res => res.subCondition.toLocaleLowerCase() === this.enteredValue.toLocaleLowerCase());
    }
    return temp;
  }

  onSelectOfSearchResultsAsObj(value: MedCondClassificationModel, resetNextQues: boolean) {
    this.enteredValue = value.subCondition;
    this.question.responseValueByUser = this.enteredValue;
    let classificationValue = MedClassificationPattern.partOne + value.classification + MedClassificationPattern.partTwo;
    this.addressData = [];
    let temp = new SubAndClassificationModel(classificationValue, value, this.controlName);
    this.syncService.setMCSubAndClassificationObj(temp);
    this.selectedData.emit(new EmitterToCtlTypeModel(classificationValue, resetNextQues, this.objToReferToRetainValueFromTabSquare, this.accordIndexToAppend, this.objToReferForAccord));
    this.parent.controls[this.controlName].setErrors(null);
  }

  onSelectOfSearchResultsAsString(value: string, resetNextQues: boolean) {
    this.enteredValue = value;
    this.question.responseValueByUser = this.enteredValue;
    this.addressData = [];
    this.selectedData.emit(new EmitterToCtlTypeModel(value, resetNextQues, this.objToReferToRetainValueFromTabSquare, this.accordIndexToAppend, this.objToReferForAccord));
    this.parent.controls[this.controlName].setErrors(null);
  }

  ngOnDestroy() {
    if (this.parent.get(this.controlName)) {
      this.parent.get(this.controlName).markAsUntouched();
    }
    this.searchLstSubs.unsubscribe();
    this.subscription.unsubscribe();
    this.enteredValue = "";
  }


  initializeToolTipDateComp(questionObj: LifeStyleQuestion): Tooltip {
    return new Tooltip(questionObj.helpText, '', false);
  }

  getErrorMsgValue(errorType: string): string {
    let msg = '';
    msg = this.question.questionText.toLowerCase().includes('condition') ? 'condition'
      : (this.question.questionText.toLowerCase().includes('medication') ? 'medication'
        : (this.question.questionText.toLowerCase().includes('surgery') ? 'surgery'
          : (this.question.questionText.toLowerCase().includes('cancer') ? 'cancer'
            : 'value')));
    return msg;
  }

  getPlaceholder(): string {
    if (this.question.origoSection.includes('current_medication')) {
      let placeholderText = 'Enter medication name';
      return placeholderText;
    } else {
      let placeholderText = 'Enter condition name';
      return placeholderText;
    }
  }
  
  displayDrpTooltipMessage(question){
    this.tooltipModal.content = question.helpText;
    this.displayTooltipAlert = true;
  }

  alertTooltipPrimaryBtnClick() {
		this.closeModal();
	}

	closeModal() {
		this.displayTooltipAlert = false;
	}
}
